import React, { useEffect } from 'react';
import { Body, SubmitButton, FormCadastro, PageHeader, DatePicker, GroupField, Field, Input } from '@components';
import { getClientesConectores } from '@ducks/clientes';
import { postFolgas, getFolga, putFolgas, reset } from '@ducks/conectoresFolgas';
import { Notification, dateToAnsi, DATE_FORMATS } from '@utils';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import TreeConectores from './TreeConectores';
import App from '@app';
import styled from 'styled-components';

const FieldObs = styled(Field)`
  flex: 2;
`;

const PeriodoPicker = styled(DatePicker.RangePicker)`
  width: 100%;
`;

const FieldConectores = styled(Field)`
  flex: 2;
`;

export default function Cadastro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id } = useParams();
  const edicao = id !== '-1';

  const folga = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('folga'));
  const clientesConectores = useSelector(({ clientes }) => clientes.get('clientesConectores').toArray());
  const conectoresSelecionados = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('conectoresSelecionados'));
  const successPostFolgas = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('successPostFolgas'));
  const successPutFolgas = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('successPutFolgas'));
  const successFolga = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('successFolga'));

  const handleReset = () => {
    return dispatch(reset());
  };

  const handleSearch = () => {
    return dispatch(getClientesConectores());
  };

  useEffect(() => {
    handleReset();
    handleSearch();
  }, []);

  useEffect(() => {
    if (successPostFolgas || successPutFolgas) {
      handleReset();
      history.goBack();
    }
  }, [successPostFolgas, successPutFolgas]);

  useEffect(() => {
    if (edicao) {
      dispatch(getFolga(id));
    }
  }, []);

  useEffect(() => {
    if (folga && edicao) {
      form.setFieldsValue(folga);
    }
  }, [successFolga]);

  function handleSubmit(data) {
    if (conectoresSelecionados.length === 0) {
      Notification.error('Selecione ao menos um conector');
      return;
    }

    const dtInicio = dateToAnsi(data.periodo[0], DATE_FORMATS.ANSI, DATE_FORMATS.ANSI_S);
    const dtFim = dateToAnsi(data.periodo[1], DATE_FORMATS.ANSI, DATE_FORMATS.ANSI_S);

    const conectores = conectoresSelecionados.map((conector) => {
      const configuracao = conector.split('-');

      if (configuracao[1] === '0') {
        const cliente = clientesConectores.find((cliente) => cliente.key === conector);

        return cliente.children.map((configuracao) => {
          return parseInt(configuracao.key.split('-')[1]);
        });
      } else {
        return parseInt(configuracao[1]);
      }
    });

    let body = [];

    conectores.forEach((conector) => {
      if (typeof conector === 'object') {
        for (let index = 0; index < conector.length; index++) {
          body.push({
            idConfiguracao: conector[index],
            obs: data.obs,
            dtInicio,
            dtFim,
          });
        }
      } else {
        body.push({
          idConfiguracao: conector,
          obs: data.obs,
          dtInicio,
          dtFim,
        });
      }
    });

    // eslint-disable-next-line
    body.map((item) => {
      item.idFolga = id;
    });

    if (edicao) {
      dispatch(putFolgas(body));
    } else {
      dispatch(postFolgas(body));
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title='Folga dos conectores' onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <FieldObs label='Descrição' name='obs' rules={[{ required: true, message: 'Informe a descrição' }]}>
                <Input autoFocus />
              </FieldObs>
              <Field label='Período' name='periodo' rules={[{ required: true, message: 'Informe o período' }]}>
                <PeriodoPicker format='DD/MM/YYYY HH:mm:ss' showTime />
              </Field>
            </GroupField>
            <GroupField>
              <FieldConectores label='Conectores'>
                <TreeConectores treeData={clientesConectores} />
              </FieldConectores>
            </GroupField>
            <SubmitButton type='success' htmlType='submit' block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
